module.exports = __webpack_public_path__ + "img/1.535becc4.png";